import { useFormContext } from "react-hook-form";

export function WhenFormIsInitialized({
  children,
  placeholder,
}: {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
}) {
  const {
    formState: { isLoading },
  } = useFormContext();
  return isLoading ? placeholder : children;
}
